import { PaymentErrorCode } from "Infrastructure/Api/Api";
import { Resources } from "Translations/Resources";

const RESOURCES = Resources.TransactionErrors;

/**
 * Message per payment failure category. The category comes from the API
 * (`transactionStatus`/`transactionDetail.failureReason`), which every failure path fills —
 * bank authorization, the bank's redirect back, status polling and the cancel sweep — for every bank.
 * `None` means nothing failed, so it has no message.
 */
const FAILURE_REASON_TO_TRANSLATION: Record<
  Exclude<PaymentErrorCode, PaymentErrorCode.None>,
  string
> = {
  [PaymentErrorCode.Unknown]: RESOURCES.UnknownPaymentError,
  [PaymentErrorCode.InsufficientBalance]: RESOURCES.InsufficientBalance,
  [PaymentErrorCode.LimitExceeded]: RESOURCES.PaymentLimitExceeded,
  [PaymentErrorCode.Rejected]: RESOURCES.PaymentRejectedByBank,
  [PaymentErrorCode.UserCancelled]: RESOURCES.PaymentCancelledByUser,
  [PaymentErrorCode.Expired]: RESOURCES.PaymentExpired,
  [PaymentErrorCode.Unauthorized]: RESOURCES.PaymentUnauthorized,
  [PaymentErrorCode.Technical]: RESOURCES.PaymentTechnicalError,
};

export const getPaymentFailureMessageKey = (
  failureReason: PaymentErrorCode | undefined,
): string | undefined =>
  !failureReason || failureReason === PaymentErrorCode.None
    ? undefined
    : FAILURE_REASON_TO_TRANSLATION[failureReason];
